import { atomHelpers } from '@approvalmax/utils';
import { atom } from 'jotai';
import { setChameleonOrgId } from 'modules/utils/helpers/chameleon';

const activeCompanyIdWithLocalStoreAtom = atomHelpers.createAtomWithStorage<string>(
    'activeCompanyIdWithLocalStoreState',
    ''
);

export const activeCompanyIdState = atom(
    (get) => get(activeCompanyIdWithLocalStoreAtom),
    (get, set, orgId: string) => {
        setChameleonOrgId(orgId);
        set(activeCompanyIdWithLocalStoreAtom, orgId);
    }
);
